import React from "react";
import {Checkbox, FormControlLabel} from "@mui/material";
import {AppField} from "../fields";
import {forms, objects} from "@atttomyx/shared-utils";

const AccountForm = (props) => {
    const { apps, appRenderer, data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;

        modified.valid = !!modified.appId;

        onSync(modified);
    }

    return <div className="account-form">
        <div className="field">
            <AppField
                apps={apps}
                appRenderer={appRenderer}
                required={true}
                value={data.appId}
                onChange={(appId) => onChange("appId", appId)}
            />
        </div>
        <div className="option">
            <FormControlLabel labelPlacement="end"
                              label="Disabled"
                              control={<Checkbox color="primary"
                                                 checked={forms.sanitizeOption(data.disabled)}
                                                 onChange={(event) => onChange("disabled", event.target.checked)}
                              />}
            />
        </div>
        <div className="option">
            <FormControlLabel labelPlacement="end"
                              label="Allow new users to join"
                              control={<Checkbox color="primary"
                                                 checked={forms.sanitizeOption(data.allowJoin)}
                                                 onChange={(event) => onChange("allowJoin", event.target.checked)}
                              />}
            />
        </div>
    </div>
}

export default AccountForm;
